import { render, staticRenderFns } from "./ModalEditPress.vue?vue&type=template&id=6d4ce2bc&scoped=true"
import script from "./ModalEditPress.vue?vue&type=script&lang=js"
export * from "./ModalEditPress.vue?vue&type=script&lang=js"
import style0 from "./ModalEditPress.vue?vue&type=style&index=0&id=6d4ce2bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4ce2bc",
  null
  
)

export default component.exports